<template lang="pug">
  .testimonial-quote
    blockquote.testimonial-quote__quote
      span.testimonial-quote__large-quote “
      | {{ quote.quote }} ”
    .testimonial-quote__text
      p.testimonial-quote__name {{ `-${quote.name}, ${quote.city}` }}
      .testimonial-quote__cta(v-if="quote.ctaUrl")
        a.testimonial-quote__button(:href="quote.ctaUrl") {{quote.ctaText}}
</template>

<script>

  export default {
    props: {
      quote: {
        type: Object,
        default: () => ({
          name: String,
          city: String,
          profileImage: String,
          featuredImage: {
            src: String,
            alt: String,
          },
          quote: String,
          ctaUrl : String,
          ctaText : String
        }),
      },
    },
  };
</script>

<style lang="scss">
  .testimonial-quote {
    padding: 0 30px;

    @include desktop-up {
      padding: 0;
    }
  }

  .testimonial-quote__quote {
    margin: 0;
    color: $color-green-900;
    font-size: rem(18);
    font-family: $font-headings;
    line-height: rem(40);

    @include desktop-up {
      font-size: rem(24);
    }
  }

  .testimonial-quote__large-quote {
    position: relative;
    top: 45px;
    left: -5px;
    margin-right: 5px;
    color: $color-green-900;
    font-size: rem(80);
    line-height: 0;
  }

  .testimonial-quote__name {
    margin: 16px 0 0 0;
    color: $color-green-900;
    font-size: rem(16);
    line-height: rem(22);
    text-align: center;

    @include desktop-up {
      text-align: left;
    }
  }

  .testimonial-quote__text {
    display: flex;
    justify-content: space-between;;
    align-items: flex-end;

    .testimonial-quote__button {
      color: $color-green-900;
      font-size: rem(16);
      line-height: rem(22);
      text-transform: uppercase;
    }
  }
</style>
